import React, { useEffect, useState } from 'react';
import useAsync from '../hooks/useAsync';
import { useNavigate } from 'react-router-dom';

import UserServices from '../services/UserServices';
import TogalButtonForStatus from './TogelButton/TogalButtonForStatus';
import UserUpdate from './Update Model/UpdateUser';
import ViewUser from './View Model/ViewUser';
import DeleteButton from './Button/DeleteButton';
import Modal from 'react-modal';
import UserStatus from './TogelButton/UserStatus';
import ReactPaginate from 'react-paginate';
import * as XLSX from 'xlsx';
import { FaRegEye } from "react-icons/fa";
import { Tooltip } from 'react-tooltip'
Modal.setAppElement('#root');

function InActiveUserManager() {
  const { data, error, isLoading, run } = useAsync(UserServices.getINActiveUsers);

  console.log("sdasfsfsdfs", data);

  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const [activeIndex, setActiveIndex] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userTypeFilter, setUserTypeFilter] = useState('');
  const [planFilter, setPlanFilter] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredData, setFilteredData] = useState(data?.data || []);

  const handleViewDetails = (user) => {
    setSelectedUser(user);
    setIsModalOpen(true);
  };

  const handleEditDetails = (help) => {
    setSelectedEdit(help);
    setIsEditModalOpen(true);
    toggleActionMenu(null);
  };

  const handleDelete = (help) => {
    setSelectedEdit(help);
    setIsDeleteModalOpen(true);
    toggleActionMenu(null);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedEdit(null);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setSelectedEdit(null);
  };

  // Define closeModal function for closing the ViewUser modal
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedUser(null);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString();
    return `${day}-${month}-${year}`;
  };

  const usersPerPage = 20;
  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;

  const filteredUsers = (data?.data || []).filter((user) => {
    const fullName = `${user?.firstName || ''} ${user?.lastName || ''}`.toLowerCase();
    const email = user?.email ? user.email.toLowerCase() : '';
    const mobileNo = user?.mobileNo ? user.mobileNo.toString() : '';
    const matchesUserType = userTypeFilter
      ? user.deviceType && user.deviceType.toLowerCase() === userTypeFilter.toLowerCase()
      : true;
    const matchesPlan =
      planFilter === 'hasPlan'
        ? !!user?.subcription?.plan?.planName
        : planFilter === 'noPlan'
          ? !user?.subcription?.plan?.planName
          : true;

    return (
      (fullName.includes(searchQuery.toLowerCase()) ||
        email.includes(searchQuery.toLowerCase()) ||
        mobileNo.includes(searchQuery)) &&
      matchesUserType &&
      matchesPlan
    );
  });

  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

  const generateExcel = () => {
    const filteredData = filteredUsers?.map((user, index) => ({
      SNo: index + 1, // Adding serial number
      UserType: user?.deviceType,
      Name: user?.firstName,
      Plan: user?.subcription?.plan?.planName,
      OrderNumber: user?.orderId,
      MobileNo: user?.mobileNo,
      Email: user?.email,
      State: user?.state,
      City: user?.city,
      Building: user?.bulding,
      AddressType: user?.apartment,
      Floor: user?.floor,
      Street: user?.street,
      Address: user?.address,
      Date: formatDate(user?.createdAt),
      Status: user?.status,
    }));

    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Users');
    XLSX.writeFile(wb, 'user_data.xlsx');
  };

  const handlePageClick = (data) => {
    setCurrentPage(data.selected + 1);
  };
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  const toggleActionMenu = (index) => {
    setActiveIndex(index === activeIndex ? null : index); // Toggle the active index
  };
  const handleUserTypeChange = (e) => {
    setUserTypeFilter(e.target.value);
  };

  const handlePlanChange = (e) => {
    setPlanFilter(e.target.value);
  };

  return (
    <div className="right_col" role="main">
      <div className="d-md-flex  align-items-center justify-content-between my-4 page-header-breadcrumb">

        <div className="my-auto">

          <h5 className="page-title fs-21 mb-1">Inactive User    <span className="badge bg-warning" /></h5>
          <nav>

            <ol className="breadcrumb mb-0">

              <li className="breadcrumb-item">
                <a href="javascript:void(0);">Home</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Inactive User List
              </li>
            </ol>
          </nav>
        </div>
        <div className="d-flex my-xl-auto right-content align-items-center">

          <div className="pe-1 mb-xl-0">

            <div className="sub-title-box-right d-flex" style={{ gap: 20 }}>
              <button className="excel-btn" onClick={generateExcel}>
                <img src="img/excel.svg" alt="Download Excel" />
                Download
              </button>
            </div>
          </div>



        </div>
      </div>

      <div className="container-box px-0 user-manager">
        <div className="Tablesearch_design">
          <div className='row'>
            <div className='col-md-6'>
              <div className='d-flex align-items-center justify-content-between gap-2'>
                <div className=' w-100'>

                  <input
                    type="search"
                    name="search"
                    placeholder="Search by Name, Mobile and Email id"
                    value={searchQuery}
                    onChange={handleSearchChange}
                    className='form-control'

                  />
                </div>
                <div>

                  <button className="search-btn">Search</button>
                </div>
              </div>
            </div>
            <div className="col-sm-3 col-6">
            <div className="input-field">
              <select className="form-select selectcustum" value={userTypeFilter} onChange={handleUserTypeChange}>
                <option value="">User Type</option>
                <option value="Android">Android</option>
                <option value="iOS">iOS</option>
              </select>
            </div>
          </div>
            <div className="col-sm-3 col-6">

            <div className="input-field">
              <select className="form-select selectcustum" value={planFilter} onChange={handlePlanChange}>
                <option value="">Filter</option>
                <option value="hasPlan">Plan Holder</option>
                <option value="noPlan">No Plan</option>
              </select>
            </div>
          </div>
          </div>


        </div>
        <div className="container-box-inner table-reponsive-tabe">
          <table id="example" className="table table-striped" style={{ width: "100%" }}>
            <thead>
              <tr>
                <th>#</th>
                <th>USER TYPE</th>
                <th>IMAGE</th>
                <th>NAME</th>
                <th>MOBILE NO.</th>
                <th>ADDRESS</th>
                <th>REGISTRATION DATE</th>
                {/* <th>PLAN</th> */}
                {/* <th>STATUS</th> */}
                {/* <th>ORDER NUMBER</th> */}
                <th>ACTION</th>
              </tr>
            </thead>
            <tbody>
              {currentUsers?.map((user, index) => (
                <tr key={user?.id || index}> {/* Ensure a unique key for each row */}
                  <td>{index + 1 + indexOfFirstUser}</td>

                  <td> <span class="usertype">{user?.deviceType || "N/A"} </span></td>
                  <td>
                    <img src={user?.image ? `${process.env.REACT_APP_URL}${user?.image}` : 'img/profile-img.png'} alt="" style={{ height: '50px', width: '50px', objectFit: 'contain' }} />
                  </td>
                  <td style={{ maxWidth: '100px', wordWrap: 'break-word' }}>{`${user?.firstName || "N/A"} ${user?.lastName || ""}`.trim() || "N/A"}</td> {/* Correct concatenation with fallback */}
                  <td>{user?.mobileNo || "N/A"}</td>
                  <td>{user?.address || "N/A"}</td>
                  <td>{user?.createdAt ? formatDate(user.createdAt) : "N/A"}</td>
                  {/* <td>{user?.subcription?.plan?.planName || "N/A"}</td> */}
                  {/* <td className="status-toggle">
                    <TogalButtonForStatus data={user} page="user" onSuccess={() => run()} />
                  </td> */}
                  {/* <td>
                    <button
                      onClick={() => navigate(`/order?userId=${user?.id}`)}
                      style={{ background: 'none', border: 'none', color: 'blue', cursor: 'pointer' }}
                    >
                      {user?.TotalOrder || "N/A"}
                    </button>
                  </td> */}
                  <td className="view-cities-button" onClick={() => handleViewDetails(user)}>
                    <FaRegEye className="custom-icon" />
                    <Tooltip id="view-cities-tooltip" />
                  </td>
                  {/* <td>
                    <div className="action_toggle_outer">
                      <button className="action_toggle" onClick={() => toggleActionMenu(index)}>
                        <i className="fa fa-ellipsis-v" />
                      </button>
                      {activeIndex === index && (
                        <div className="action_toggle_content product-edit show d-block">
                          <ul className="list-unstyled">
                            <li>
                              <button className="close_toggle" onClick={() => toggleActionMenu(null)}>
                                <i className="fa fa-close" />
                              </button>
                            </li>
                            <li>
                              <button className="edit" onClick={() => handleEditDetails(user)}>Edit</button>
                            </li>
                            <li>
                              <button className="reject" onClick={() => handleDelete(user)}>Delete</button>
                            </li>
                            <li>
                              <button className="approve" style={{ backgroundColor: '#263238' }} onClick={() => handleViewDetails(user)}>View</button>
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="pagination">
          <ReactPaginate
            pageCount={Math.ceil((filteredUsers?.length || 0) / usersPerPage)}
            pageRangeDisplayed={3}
            marginPagesDisplayed={1}
            onPageChange={handlePageClick}
            containerClassName={'pagination'}
            activeClassName={'active'}
            previousLabel={'Previous'}
            nextLabel={'Next'}
            breakLabel={'...'}
            breakClassName={'break-me'}
            initialPage={currentPage - 1}
            disableInitialCallback={true}
            pageLinkClassName={'page-link'}
            previousLinkClassName={'page-link'}
            nextLinkClassName={'page-link'}
            pageClassName={'page-item'}
            previousClassName={'page-item'}
            nextClassName={'page-item'}
            disabledClassName={'disabled'}
          />
        </div>

      </div>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="User Details"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <ViewUser user={selectedUser} closeModal={closeModal} />
      </Modal>
      <Modal
        isOpen={isEditModalOpen}
        onRequestClose={closeEditModal}
        contentLabel="User Details"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <UserUpdate user={selectedEdit} closeModal={closeEditModal} onSuccess={run} />
      </Modal>
      <Modal
        isOpen={isDeleteModalOpen}
        onRequestClose={closeDeleteModal}
        contentLabel="Delete Confirmation"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <DeleteButton data={selectedEdit} page="User" closeModal={closeDeleteModal} onSuccess={run} />
      </Modal>


    </div>
  );
}

export default InActiveUserManager;
